// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/carousel-banner-img.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customer-dashboard-wrapper {
  background-color: #f0f0f0;
}

.task-completion-track-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  text-align: center;
  background: #FAFAFA;
  border: 2px solid #F2F2F2;
  border-radius: 6px;
  height: 100%;
}

.centered-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.progress-bar-container {
  display: flex;
  justify-content: space-between;
}

.progress-bar-stripe {
  margin: 0 5px;
  /* Adjust the spacing between stripes */
}

.dashboard-container.container {
  max-width: 1783px;
  width: 100%;
  padding: 50px 20px;
}

.customer-dashboard-wrapper .carousel-container {
  background: #FFFFFF;
  border: 1px solid #EFEFEF;
  border-radius: 9px;
}

.card-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.content-card {
  border-radius: 0;
  max-width: 348px;
}

.content-card.blue {
  background: #E2F4FB;
  border: 2px solid #CDECF8;
}

.content-card.blue .card-footer {
  border-top: 2px solid #CDECF8;
  background: transparent;
}

.content-card.lightgrey {
  background: rgba(48, 105, 175, 0.12);
  border: 2px solid #CBD9EA;
}

.content-card.lightgrey .card-footer {
  border-top: 2px solid #CBD9EA;
  background: transparent;
}

.content-card.darkgrey {
  background: #D3D9E8;
  border: 2px solid #BFCAE7;
}

.content-card.darkgrey .card-footer {
  border-top: 2px solid #BFCAE6;
  background: transparent;
}

.content-card.yellow {
  background: rgba(255, 203, 53, 0.12);
  border: 2px solid #F1EBD7;
}

.content-card.yellow .card-footer {
  border-top: 2px solid #F1EBD7;
  background: transparent;
}


.carousel-card .slick-arrow.slick-prev,
.carousel-card .slick-arrow.slick-next,
.carousel-card .slick-dots {
  display: none !important;
}

.left-side {
  position: relative;
  padding: 0;
}

.right-side {
  padding: 0;
}

.background-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  filter: blur(15px);
  transform: matrix(-1, 0, 0, 1, 0, 0);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  /* Replace with your background image */
  background-size: cover;
  background-position: center;
}

.left-side .content {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #fff;
  padding: 20px;
}

.carousel-slide .carousel-image {
  width: 100%;
  display: block;
  max-width: 100%;
  height: 320px
}

.right-side .slick-arrow.slick-next,
.right-side .slick-arrow.slick-prev {
  display: none !important;
}

.right-side .slick-dots {
  left: -100%;
  bottom: 20px;
  text-align: left;
}

.right-side .slick-dots li.slick-active button:before {
  opacity: 1;
  color: #00863F;
  font-size: 13px;
}

.right-side .slick-dots li button:before {
  opacity: 1;
  color: #fff;
  font-size: 13px;
}

.slide-item {
  display: flex !important;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* description page css */
.description-wrapper {
  background-color: #f0f0f0;
}

.description-wrapper .title-wrapper {
  background-color: #E2F4FB;
  padding: 44px 20px;
}

.description-wrapper .circle-nav {
  background: linear-gradient(0deg, #F5F5F5, #F5F5F5),
    linear-gradient(0deg, #FEFEFE, #FEFEFE);
  border: 1px solid #F5F5F5;
  box-shadow: 0px 4px 4px 0px #0000000D;
  border-radius: 50px;
  padding: 7px;
}

.section-nav .nav-link {
  background: linear-gradient(0deg, #FFFFFF, #FFFFFF);
  border: 1.5px solid #D9D9D9;
  border-radius: 40px;
  padding: 26px 32px;
  font-size: 22px;
  line-height: 22px;
  color: #424242;
}

.section-nav {
  gap: 12px;
}

.section-nav.nav-pills .nav-link.active,
.section-nav.nav-pills .show>.nav-link {
  background: #00863F;
  color: #fff;
}

.description-wrapper .container {
  /* max-width: 1576px;
  padding: 20px; */
}

.description-wrapper .content-img-section {
  margin-top: 60px;
  justify-content: space-between;
}

.description-wrapper .content-img-section:first-child {
  margin-top: 0px;
}

.description-wrapper .radial-border {
  background: radial-gradient(50% 50% at 50% 50%, #E7E7E7 0%, rgba(196, 196, 196, 0) 100%);
  max-width: 493px;
  height: 18px;
  width: 100%;
}

.description-wrapper .title-content-block {
  /* max-width: 626px; */
  width: 100%;
}

.nodatafound-section {
  background-color: #f0f0f0;
}

.nodatafound-section .container {
  max-width: 1718px;
  padding: 20px;
}

.no-data-card {
  max-width: 1718px;
  height: 800px;
  background-color: #fff;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.nodatafound-section #range-dropdown.btn-secondary {
  background-color: #fff;
  border: 1px solid #D5D5D5;
  font-family: Open Sans;
  font-size: 22px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: 0.25px;
  text-align: left;
  color: #424242;
  padding: 15px 13px;
}

.sharefeedback-section {
  background-color: #f0f0f0;
}

.sharefeedback-section .container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  max-width: 900px;
  padding: 100px 0;
}

.cat-survey-wrapper,
.nat-survey-section {
  background-color: #F7F7F7;
}

.cat-survey-wrapper .container {
  max-width: 1640px;
}

.cat-survey-wrapper .custom-checkbox {
  margin-top: 0px;
  background-color: #fff;
  padding: 25px;
  margin-bottom: 0;
  border: 2px solid #ededed
}

.cat-survey-wrapper .custom-checkbox:first-child {
  margin-top: 20px;
}

.cat-survey-wrapper .custom-checkbox:last-child {
  margin-bottom: 25px;
}

.cat-survey-wrapper .custom-checkbox .form-check-input {
  border: 2px solid #AFAFAF;
  background-color: #eee;
  width: 26px;
  height: 26px;
}

.cat-survey-wrapper .custom-checkbox .form-check-input:checked {
  background-color: #84FFBE52;
  border-color: #fff;

}

.cat-survey-wrapper .custom-checkbox .form-label {
  color: #54595F;
  font-size: 22px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0.25px;
  text-align: left;
}

.cat-survey-wrapper .checkbox-section {
  background-color: #EDEDED;
}

.cat-survey-wrapper .checkbox-content {
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
  color: #54595F;
}

.cat-survey-wrapper ul.checkbox-content {
  padding-left: 1rem;
}

.cat-survey-wrapper .checkbox-content.selected {
  color: #fff;
}

.buttons-container {
  border-top: 1px solid #E1E1E1;
}

.survey-btn {
  background-color: #fff;
  color: #00863F;
  border: none;
  border-radius: none;
  font-family: 'Open Sans', sans-serif;
  padding: 14px 25px;
}

.btn.survey-btn:hover,
.btn.survey-btn:active,
.btn.survey-btn:focus {
  background-color: #fff;
  color: #00863F;
  border: none;
}

.custom-checkbox.selected {
  box-shadow: 2px 10px 9px 0px #00000024;
}

#avatar-dropdown::after {
  display: none;
}

#avatar-dropdown.btn {
  background-color: transparent;
}

.nat-survey-wrapper .container {
  max-width: 1670px;
}

.tab-pills-container .rounded-pill.nav-link {
  padding: 26px 32px 26px 32px;
  gap: 10px;
  border: 1.5px solid #D9D9D9;
  background: #fff;
  font-size: 22px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0.25px;
  text-align: left;
  color: #424242;
  margin: 5px;
  white-space: nowrap;
}

.tab-pills-container .rounded-pill.active.nav-link {
  background-color: #00863F;
  border-color: #00863F;
  color: #fff;
}

.tab-pills-container {
  overflow-x: auto;
}

.nav-wrapper {
  display: flex;
  align-items: center;
  padding: 1rem 0;
  gap: 1rem;
  flex-wrap: nowrap;
  overflow-x: scroll;
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* Internet Explorer and Edge */
}

.nav-wrapper::-webkit-scrollbar {
  width: 0.5em;
  background-color: transparent;
  height: 10px;
  cursor: pointer;
}

/* Hide the scrollbar thumb */
.nav-wrapper::-webkit-scrollbar-thumb {
  background-color: #54595F;
  border-radius: 20px;
}

/* Hide the scrollbar track */
.nav-wrapper::-webkit-scrollbar-track {
  background-color: transparent;
}

.left-tab-content {
  background-color: #fff;
  padding: 30px;
  border: 1px solid #DCDCDC
}

.left-tab-content .checkbox-accordion .accordion-header {
  background-color: #fff;
  box-shadow: 6px 4px 7px 0px #0000000D;
  border: 1px solid #E1E1E1;
}

.left-tab-content .checkbox-accordion .accordion-item {
  margin-bottom: 40px;
  border: none;
}

.left-tab-content .checkbox-accordion .accordion-item:first-of-type .accordion-button {
  background-color: transparent;
  border-radius: 0;
}

.left-tab-content .checkbox-accordion .accordion-item:first-of-type {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.left-tab-content .checkbox-accordion .accordion-item:last-of-type {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  margin-bottom: 0;
}

.left-tab-content .checkbox-accordion .accordion-body {
  margin-top: 20px;
  border-left: 3px solid #D9D9D9;
}

.left-tab-content .checkbox-accordion .accordion-header {
  font-family: Open Sans;
}

.left-tab-content .checkbox-accordion .checkbox-body .form-check-label {
  font-family: Open Sans;
  font-size: 20px;
  font-weight: 400;
  line-height: 27px;
  letter-spacing: 0em;
  text-align: left;
  margin-left: 10px;
}

.left-tab-content .checkbox-accordion .checkbox-body .form-check {
  margin-bottom: 20px;
}

.left-tab-content .checkbox-accordion .checkbox-body .form-check-input:checked {
  background-color: #00863F;
  border-color: #00863F;
}

.left-tab-content .checkbox-accordion .checkbox-body .form-check-input {
  width: 21px;
  height: 21px;
}

.right-tab-content {
  background-color: #fff;
  padding: 30px;
  border: 1px solid #DCDCDC;
  display: flex;
  flex-direction: column;
  height:auto;
}

.right-tab-content .icon-circle {
  border-radius: 40px;
  border: 1.5px solid #D9D9D9;
  background-color: #fff;
  padding: 11px;
}

.nat-survey-section {
  padding: 20px;
}

.right-tab-content .btn {
  font-family: Open Sans;
}

.save-job-modal .form-control {
  border: 1px solid #DAD9DC;
  height: 47px;
  max-width: 535px;
}

.save-job-modal .form-label {
  color: #1A1A1A;
  font-size: 18px;
  font-weight: 500;
  line-height: 23px;
  letter-spacing: 0em;
  text-align: left;
}

.circle-line {
  border-left: 1px solid #D9D9D9;
  position: relative;
  display: block;
  margin-bottom: 40px;
}

.circle-line::after {
  content: '';
  position: absolute;
  top: 0px;
  left: -4px;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #d9d9d9;
}

.nat-survey-section .level-checkbox .form-check-input {
  width: 21px;
  height: 21px;
  border-radius: 4px;
  border: 1px solid #797979;
}

.dashboard-slider-block .slick-track {
  display: flex;
}

.dashboard-slider-block .slick-slide {
  display: flex;
  height: auto;
  flex: 1 1;
}

.dashboard-slider-block .slide-item {
  height: 100%;
}

.dashboard-slider-block .content-card {
  display: flex;
  flex-direction: column;
  flex: 1 1;
}

.dashboard-slider-block .content-card .card-footer {
  margin-top: auto;
}

.feedback-page {
  background-color: #F7F7F7;
}

.feedback-form .form-check-input:checked[type=radio] {
  --bs-form-check-bg-image: none;
}

.feedback-form .form-check {
  margin-bottom: 17px;
}

.feedback-form .form-label {
  margin-bottom: 18px;
}

.feedback-form .form-control {
  max-width: 535px;
  height: 47px;
  border-radius: 2px;
  border: 1px solid #DAD9DC;
}
.feedback-form .form-control::placeholder{
  color: #00000080;
}
.feedback-form label.form-check-label {
  font-family: Open Sans;
  font-size: 20px;
  font-weight: 400;
  line-height: 27px;
  letter-spacing: 0em;
  text-align: left;
  margin-left: 10px;
  color: #000;
}
.feedback-form .form-check-input{
  width: 21px;
  height: 21px;
  border: 1px solid #D3D3D3
}

.job-description-list{
  height: 600px;
  overflow-y: auto;
}

.job-description-list::-webkit-scrollbar {
  width: 0.5em;
  background-color: #eeee ;
  height: 10px;
  cursor: pointer;
}

.job-description-list::-webkit-scrollbar-thumb {
  background-color: #9c9c9cdd;
  border-radius: 20px;
}

.job-description-list::-webkit-scrollbar-track {
  background-color:transparent;
}
.help-page-wrapper{
  background-color: #f0f0f0;
}
.help-page-wrapper .container{
  max-width: 1200px;
  padding: 20px;
}
.help-page-wrapper .title-wrapper {
  background-color: #E2F4FB;
  padding: 44px 20px;
}

.sticky-right-content {
  position: sticky;
  top: 20px;
  height: calc(100vh - 20px);
  overflow-y: auto;
}

.view-icon {
  width: 24px;
}


@media(max-width:992px) {
  .right-side .slick-dots {
    position: relative;
    text-align: center;
    left: unset;
    right: unset;
    bottom: unset;
  }

  .cat-survey-wrapper .custom-checkbox {
    padding: 15px;
  }

  .left-tab-content,
  .right-tab-content {
    padding: 10px;
    margin-top: 20px;
  }
}

.loader-container {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.834);
  z-index: 1;
}

.spinner {
  width: 64px;
  height: 64px;
  border: 8px solid;
  border-color: #3d5af1 transparent #3d5af1 transparent;
  border-radius: 50%;
  animation: spin-anim 1.2s linear infinite;
}

@keyframes spin-anim {
  0% {
      transform: rotate(0deg);
  }
  100% {
      transform: rotate(360deg);
  }
}

.nat-survey-section 
.sticky-top-content {
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #fff; /* Change the background color to your preference */
  z-index: 1000; /* Adjust the z-index to your needs */
}

.nat-survey-section .help-tab-wrapper li.active {
  background-color: #00863F;
  color: #fff;
  border-radius: 0;
}

.nat-survey-section .help-tab-wrapper li {
  padding: 10px;
  margin: 10px;
}

@media(max-width:767.5px){
  .tab-pills-container .nav-wrapper{
    flex-wrap: wrap;
  }
  /* .sticky-top-content {
    position: sticky;
    height: auto;
    top: 0;
    background-color: #fff;
    z-index: 10;
} */
}`, "",{"version":3,"sources":["webpack://./src/screens/dashboard/dashboard.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;AACzB;;;AAGA;;;EAGE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,yDAAoE;EACpE,uCAAuC;EACvC,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf;AACF;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE;2CACyC;EACzC,yBAAyB;EACzB,qCAAqC;EACrC,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mDAAmD;EACnD,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE;kBACgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wFAAwF;EACxF,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;;AAEpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;;;EAGE,sBAAsB;EACtB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,YAAY;EACZ,eAAe;AACjB;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb;AACF;;AAEA;EACE,sBAAsB;EACtB,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;AACT;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ;AACF;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE;IACE,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,aAAa;IACb,gBAAgB;EAClB;AACF;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gCAAgC;EAChC,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,qDAAqD;EACrD,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE;MACI,uBAAuB;EAC3B;EACA;MACI,yBAAyB;EAC7B;AACF;;AAEA;;EAEE,gBAAgB;EAChB,MAAM;EACN,OAAO;EACP,WAAW;EACX,sBAAsB,EAAE,mDAAmD;EAC3E,aAAa,EAAE,qCAAqC;AACtD;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE;IACE,eAAe;EACjB;EACA;;;;;;GAMC;AACH","sourcesContent":[".customer-dashboard-wrapper {\n  background-color: #f0f0f0;\n}\n\n.task-completion-track-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  text-align: center;\n  background: #FAFAFA;\n  border: 2px solid #F2F2F2;\n  border-radius: 6px;\n  height: 100%;\n}\n\n.centered-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 20px;\n}\n\n.progress-bar-container {\n  display: flex;\n  justify-content: space-between;\n}\n\n.progress-bar-stripe {\n  margin: 0 5px;\n  /* Adjust the spacing between stripes */\n}\n\n.dashboard-container.container {\n  max-width: 1783px;\n  width: 100%;\n  padding: 50px 20px;\n}\n\n.customer-dashboard-wrapper .carousel-container {\n  background: #FFFFFF;\n  border: 1px solid #EFEFEF;\n  border-radius: 9px;\n}\n\n.card-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.content-card {\n  border-radius: 0;\n  max-width: 348px;\n}\n\n.content-card.blue {\n  background: #E2F4FB;\n  border: 2px solid #CDECF8;\n}\n\n.content-card.blue .card-footer {\n  border-top: 2px solid #CDECF8;\n  background: transparent;\n}\n\n.content-card.lightgrey {\n  background: rgba(48, 105, 175, 0.12);\n  border: 2px solid #CBD9EA;\n}\n\n.content-card.lightgrey .card-footer {\n  border-top: 2px solid #CBD9EA;\n  background: transparent;\n}\n\n.content-card.darkgrey {\n  background: #D3D9E8;\n  border: 2px solid #BFCAE7;\n}\n\n.content-card.darkgrey .card-footer {\n  border-top: 2px solid #BFCAE6;\n  background: transparent;\n}\n\n.content-card.yellow {\n  background: rgba(255, 203, 53, 0.12);\n  border: 2px solid #F1EBD7;\n}\n\n.content-card.yellow .card-footer {\n  border-top: 2px solid #F1EBD7;\n  background: transparent;\n}\n\n\n.carousel-card .slick-arrow.slick-prev,\n.carousel-card .slick-arrow.slick-next,\n.carousel-card .slick-dots {\n  display: none !important;\n}\n\n.left-side {\n  position: relative;\n  padding: 0;\n}\n\n.right-side {\n  padding: 0;\n}\n\n.background-image {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  filter: blur(15px);\n  transform: matrix(-1, 0, 0, 1, 0, 0);\n  background-image: url('../../assets/images/carousel-banner-img.svg');\n  /* Replace with your background image */\n  background-size: cover;\n  background-position: center;\n}\n\n.left-side .content {\n  position: relative;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  color: #fff;\n  padding: 20px;\n}\n\n.carousel-slide .carousel-image {\n  width: 100%;\n  display: block;\n  max-width: 100%;\n  height: 320px\n}\n\n.right-side .slick-arrow.slick-next,\n.right-side .slick-arrow.slick-prev {\n  display: none !important;\n}\n\n.right-side .slick-dots {\n  left: -100%;\n  bottom: 20px;\n  text-align: left;\n}\n\n.right-side .slick-dots li.slick-active button:before {\n  opacity: 1;\n  color: #00863F;\n  font-size: 13px;\n}\n\n.right-side .slick-dots li button:before {\n  opacity: 1;\n  color: #fff;\n  font-size: 13px;\n}\n\n.slide-item {\n  display: flex !important;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n/* description page css */\n.description-wrapper {\n  background-color: #f0f0f0;\n}\n\n.description-wrapper .title-wrapper {\n  background-color: #E2F4FB;\n  padding: 44px 20px;\n}\n\n.description-wrapper .circle-nav {\n  background: linear-gradient(0deg, #F5F5F5, #F5F5F5),\n    linear-gradient(0deg, #FEFEFE, #FEFEFE);\n  border: 1px solid #F5F5F5;\n  box-shadow: 0px 4px 4px 0px #0000000D;\n  border-radius: 50px;\n  padding: 7px;\n}\n\n.section-nav .nav-link {\n  background: linear-gradient(0deg, #FFFFFF, #FFFFFF);\n  border: 1.5px solid #D9D9D9;\n  border-radius: 40px;\n  padding: 26px 32px;\n  font-size: 22px;\n  line-height: 22px;\n  color: #424242;\n}\n\n.section-nav {\n  gap: 12px;\n}\n\n.section-nav.nav-pills .nav-link.active,\n.section-nav.nav-pills .show>.nav-link {\n  background: #00863F;\n  color: #fff;\n}\n\n.description-wrapper .container {\n  /* max-width: 1576px;\n  padding: 20px; */\n}\n\n.description-wrapper .content-img-section {\n  margin-top: 60px;\n  justify-content: space-between;\n}\n\n.description-wrapper .content-img-section:first-child {\n  margin-top: 0px;\n}\n\n.description-wrapper .radial-border {\n  background: radial-gradient(50% 50% at 50% 50%, #E7E7E7 0%, rgba(196, 196, 196, 0) 100%);\n  max-width: 493px;\n  height: 18px;\n  width: 100%;\n}\n\n.description-wrapper .title-content-block {\n  /* max-width: 626px; */\n  width: 100%;\n}\n\n.nodatafound-section {\n  background-color: #f0f0f0;\n}\n\n.nodatafound-section .container {\n  max-width: 1718px;\n  padding: 20px;\n}\n\n.no-data-card {\n  max-width: 1718px;\n  height: 800px;\n  background-color: #fff;\n  padding: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n.nodatafound-section #range-dropdown.btn-secondary {\n  background-color: #fff;\n  border: 1px solid #D5D5D5;\n  font-family: Open Sans;\n  font-size: 22px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: 0.25px;\n  text-align: left;\n  color: #424242;\n  padding: 15px 13px;\n}\n\n.sharefeedback-section {\n  background-color: #f0f0f0;\n}\n\n.sharefeedback-section .container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  max-width: 900px;\n  padding: 100px 0;\n}\n\n.cat-survey-wrapper,\n.nat-survey-section {\n  background-color: #F7F7F7;\n}\n\n.cat-survey-wrapper .container {\n  max-width: 1640px;\n}\n\n.cat-survey-wrapper .custom-checkbox {\n  margin-top: 0px;\n  background-color: #fff;\n  padding: 25px;\n  margin-bottom: 0;\n  border: 2px solid #ededed\n}\n\n.cat-survey-wrapper .custom-checkbox:first-child {\n  margin-top: 20px;\n}\n\n.cat-survey-wrapper .custom-checkbox:last-child {\n  margin-bottom: 25px;\n}\n\n.cat-survey-wrapper .custom-checkbox .form-check-input {\n  border: 2px solid #AFAFAF;\n  background-color: #eee;\n  width: 26px;\n  height: 26px;\n}\n\n.cat-survey-wrapper .custom-checkbox .form-check-input:checked {\n  background-color: #84FFBE52;\n  border-color: #fff;\n\n}\n\n.cat-survey-wrapper .custom-checkbox .form-label {\n  color: #54595F;\n  font-size: 22px;\n  font-weight: 400;\n  line-height: 22px;\n  letter-spacing: 0.25px;\n  text-align: left;\n}\n\n.cat-survey-wrapper .checkbox-section {\n  background-color: #EDEDED;\n}\n\n.cat-survey-wrapper .checkbox-content {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 19px;\n  letter-spacing: 0em;\n  text-align: left;\n  color: #54595F;\n}\n\n.cat-survey-wrapper ul.checkbox-content {\n  padding-left: 1rem;\n}\n\n.cat-survey-wrapper .checkbox-content.selected {\n  color: #fff;\n}\n\n.buttons-container {\n  border-top: 1px solid #E1E1E1;\n}\n\n.survey-btn {\n  background-color: #fff;\n  color: #00863F;\n  border: none;\n  border-radius: none;\n  font-family: 'Open Sans', sans-serif;\n  padding: 14px 25px;\n}\n\n.btn.survey-btn:hover,\n.btn.survey-btn:active,\n.btn.survey-btn:focus {\n  background-color: #fff;\n  color: #00863F;\n  border: none;\n}\n\n.custom-checkbox.selected {\n  box-shadow: 2px 10px 9px 0px #00000024;\n}\n\n#avatar-dropdown::after {\n  display: none;\n}\n\n#avatar-dropdown.btn {\n  background-color: transparent;\n}\n\n.nat-survey-wrapper .container {\n  max-width: 1670px;\n}\n\n.tab-pills-container .rounded-pill.nav-link {\n  padding: 26px 32px 26px 32px;\n  gap: 10px;\n  border: 1.5px solid #D9D9D9;\n  background: #fff;\n  font-size: 22px;\n  font-weight: 400;\n  line-height: 22px;\n  letter-spacing: 0.25px;\n  text-align: left;\n  color: #424242;\n  margin: 5px;\n  white-space: nowrap;\n}\n\n.tab-pills-container .rounded-pill.active.nav-link {\n  background-color: #00863F;\n  border-color: #00863F;\n  color: #fff;\n}\n\n.tab-pills-container {\n  overflow-x: auto;\n}\n\n.nav-wrapper {\n  display: flex;\n  align-items: center;\n  padding: 1rem 0;\n  gap: 1rem;\n  flex-wrap: nowrap;\n  overflow-x: scroll;\n  scrollbar-width: none;\n  /* Firefox */\n  -ms-overflow-style: none;\n  /* Internet Explorer and Edge */\n}\n\n.nav-wrapper::-webkit-scrollbar {\n  width: 0.5em;\n  background-color: transparent;\n  height: 10px;\n  cursor: pointer;\n}\n\n/* Hide the scrollbar thumb */\n.nav-wrapper::-webkit-scrollbar-thumb {\n  background-color: #54595F;\n  border-radius: 20px;\n}\n\n/* Hide the scrollbar track */\n.nav-wrapper::-webkit-scrollbar-track {\n  background-color: transparent;\n}\n\n.left-tab-content {\n  background-color: #fff;\n  padding: 30px;\n  border: 1px solid #DCDCDC\n}\n\n.left-tab-content .checkbox-accordion .accordion-header {\n  background-color: #fff;\n  box-shadow: 6px 4px 7px 0px #0000000D;\n  border: 1px solid #E1E1E1;\n}\n\n.left-tab-content .checkbox-accordion .accordion-item {\n  margin-bottom: 40px;\n  border: none;\n}\n\n.left-tab-content .checkbox-accordion .accordion-item:first-of-type .accordion-button {\n  background-color: transparent;\n  border-radius: 0;\n}\n\n.left-tab-content .checkbox-accordion .accordion-item:first-of-type {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.left-tab-content .checkbox-accordion .accordion-item:last-of-type {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n  margin-bottom: 0;\n}\n\n.left-tab-content .checkbox-accordion .accordion-body {\n  margin-top: 20px;\n  border-left: 3px solid #D9D9D9;\n}\n\n.left-tab-content .checkbox-accordion .accordion-header {\n  font-family: Open Sans;\n}\n\n.left-tab-content .checkbox-accordion .checkbox-body .form-check-label {\n  font-family: Open Sans;\n  font-size: 20px;\n  font-weight: 400;\n  line-height: 27px;\n  letter-spacing: 0em;\n  text-align: left;\n  margin-left: 10px;\n}\n\n.left-tab-content .checkbox-accordion .checkbox-body .form-check {\n  margin-bottom: 20px;\n}\n\n.left-tab-content .checkbox-accordion .checkbox-body .form-check-input:checked {\n  background-color: #00863F;\n  border-color: #00863F;\n}\n\n.left-tab-content .checkbox-accordion .checkbox-body .form-check-input {\n  width: 21px;\n  height: 21px;\n}\n\n.right-tab-content {\n  background-color: #fff;\n  padding: 30px;\n  border: 1px solid #DCDCDC;\n  display: flex;\n  flex-direction: column;\n  height:auto;\n}\n\n.right-tab-content .icon-circle {\n  border-radius: 40px;\n  border: 1.5px solid #D9D9D9;\n  background-color: #fff;\n  padding: 11px;\n}\n\n.nat-survey-section {\n  padding: 20px;\n}\n\n.right-tab-content .btn {\n  font-family: Open Sans;\n}\n\n.save-job-modal .form-control {\n  border: 1px solid #DAD9DC;\n  height: 47px;\n  max-width: 535px;\n}\n\n.save-job-modal .form-label {\n  color: #1A1A1A;\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 23px;\n  letter-spacing: 0em;\n  text-align: left;\n}\n\n.circle-line {\n  border-left: 1px solid #D9D9D9;\n  position: relative;\n  display: block;\n  margin-bottom: 40px;\n}\n\n.circle-line::after {\n  content: '';\n  position: absolute;\n  top: 0px;\n  left: -4px;\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  background: #d9d9d9;\n}\n\n.nat-survey-section .level-checkbox .form-check-input {\n  width: 21px;\n  height: 21px;\n  border-radius: 4px;\n  border: 1px solid #797979;\n}\n\n.dashboard-slider-block .slick-track {\n  display: flex;\n}\n\n.dashboard-slider-block .slick-slide {\n  display: flex;\n  height: auto;\n  flex: 1;\n}\n\n.dashboard-slider-block .slide-item {\n  height: 100%;\n}\n\n.dashboard-slider-block .content-card {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n\n.dashboard-slider-block .content-card .card-footer {\n  margin-top: auto;\n}\n\n.feedback-page {\n  background-color: #F7F7F7;\n}\n\n.feedback-form .form-check-input:checked[type=radio] {\n  --bs-form-check-bg-image: none;\n}\n\n.feedback-form .form-check {\n  margin-bottom: 17px;\n}\n\n.feedback-form .form-label {\n  margin-bottom: 18px;\n}\n\n.feedback-form .form-control {\n  max-width: 535px;\n  height: 47px;\n  border-radius: 2px;\n  border: 1px solid #DAD9DC;\n}\n.feedback-form .form-control::placeholder{\n  color: #00000080;\n}\n.feedback-form label.form-check-label {\n  font-family: Open Sans;\n  font-size: 20px;\n  font-weight: 400;\n  line-height: 27px;\n  letter-spacing: 0em;\n  text-align: left;\n  margin-left: 10px;\n  color: #000;\n}\n.feedback-form .form-check-input{\n  width: 21px;\n  height: 21px;\n  border: 1px solid #D3D3D3\n}\n\n.job-description-list{\n  height: 600px;\n  overflow-y: auto;\n}\n\n.job-description-list::-webkit-scrollbar {\n  width: 0.5em;\n  background-color: #eeee ;\n  height: 10px;\n  cursor: pointer;\n}\n\n.job-description-list::-webkit-scrollbar-thumb {\n  background-color: #9c9c9cdd;\n  border-radius: 20px;\n}\n\n.job-description-list::-webkit-scrollbar-track {\n  background-color:transparent;\n}\n.help-page-wrapper{\n  background-color: #f0f0f0;\n}\n.help-page-wrapper .container{\n  max-width: 1200px;\n  padding: 20px;\n}\n.help-page-wrapper .title-wrapper {\n  background-color: #E2F4FB;\n  padding: 44px 20px;\n}\n\n.sticky-right-content {\n  position: sticky;\n  top: 20px;\n  height: calc(100vh - 20px);\n  overflow-y: auto;\n}\n\n.view-icon {\n  width: 24px;\n}\n\n\n@media(max-width:992px) {\n  .right-side .slick-dots {\n    position: relative;\n    text-align: center;\n    left: unset;\n    right: unset;\n    bottom: unset;\n  }\n\n  .cat-survey-wrapper .custom-checkbox {\n    padding: 15px;\n  }\n\n  .left-tab-content,\n  .right-tab-content {\n    padding: 10px;\n    margin-top: 20px;\n  }\n}\n\n.loader-container {\n  width: 100%;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: rgba(0, 0, 0, 0.834);\n  z-index: 1;\n}\n\n.spinner {\n  width: 64px;\n  height: 64px;\n  border: 8px solid;\n  border-color: #3d5af1 transparent #3d5af1 transparent;\n  border-radius: 50%;\n  animation: spin-anim 1.2s linear infinite;\n}\n\n@keyframes spin-anim {\n  0% {\n      transform: rotate(0deg);\n  }\n  100% {\n      transform: rotate(360deg);\n  }\n}\n\n.nat-survey-section \n.sticky-top-content {\n  position: sticky;\n  top: 0;\n  left: 0;\n  width: 100%;\n  background-color: #fff; /* Change the background color to your preference */\n  z-index: 1000; /* Adjust the z-index to your needs */\n}\n\n.nat-survey-section .help-tab-wrapper li.active {\n  background-color: #00863F;\n  color: #fff;\n  border-radius: 0;\n}\n\n.nat-survey-section .help-tab-wrapper li {\n  padding: 10px;\n  margin: 10px;\n}\n\n@media(max-width:767.5px){\n  .tab-pills-container .nav-wrapper{\n    flex-wrap: wrap;\n  }\n  /* .sticky-top-content {\n    position: sticky;\n    height: auto;\n    top: 0;\n    background-color: #fff;\n    z-index: 10;\n} */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
